
<template>
  <div
    id="contact-popover-container"
    ref="container"
    @click="$event.target.id == 'contact-popover-container' ? showContact = false : null"
    :class="{ 'popover-active': showContact, 'fixed':fixed }"
  >
    <b-button id="contact-popover-link" class="help" pill variant="outline-secondary">?</b-button>
    <b-popover
      target="contact-popover-link"
      container="contact-popover-container"
      triggers="click"
      ref="popover"
      placement="lefttop"
    >
      <h4>{{ $t('contactPopover.contact')}}</h4>
      <hr />
      <p>
        eepos GmbH
        <br />Zum Scherbusch 1
        <br />51674 Wiehl
      </p>
      <div class="d-table">
        <div class="d-table-row">
          <div class="d-table-cell">{{ $t('contactPopover.mail') }}:</div>
          <div class="d-table-cell pl-2">
            <a ref="email" href="mailto:base@eepos.de">base@eepos.de</a>
          </div>
        </div>
        <div class="d-table-row">
          <div class="d-table-cell">{{ $t('contactPopover.phone')}}:</div>
          <div class="d-table-cell pl-2">
            <a href="tel:+49226154637161">+49 2261 54637-161</a>
          </div>
        </div>
      </div>
      <hr />

      <b-spinner variant="primary" type="grow" v-if="isSending" label="Spinning"></b-spinner>
      <div v-if="successfullySent && !isSending">
        <b-alert show variant="success">{{$t('contactPopover.successfullySent')}}</b-alert>
        <div class="button-wrapper">
          <b-button variant="secondary" size="sm" @click="closePopover">{{ $t('close')}}</b-button>
        </div>
      </div>

      <div v-if="!isSending && !successfullySent">
        <p>{{ $t('contactPopover.yourMessage')}}</p>
        <b-form-textarea
          class="contact-textarea"
          v-model="contactText"
          rows="3"
          maxlength="500"
          max-rows="3"
          no-resize
        ></b-form-textarea>
        <div class="button-wrapper">
          <b-button
            variant="secondary"
            size="sm"
            @click="closePopover"
            class="mr-1"
          >{{ $t('contactPopover.cancel')}}</b-button>
          <b-button
            variant="primary"
            size="sm"
            @click="buttonSend"
          >{{ $t('contactPopover.sendMessage')}}</b-button>
        </div>
      </div>
    </b-popover>
  </div>
</template>
<script>
export default {
  data() {
    return {
      contactText: "",
      showContact: false,
      isSending: false,
      successfullySent: false,
    };
  },
  props: {
    fixed: Boolean,
  },

  methods: {
    async buttonSend() {
      const message = this.contactText;
      this.contactText = "";
      this.$refs.email.focus();
      if (!/^\s*$/.test(message)) {
        this.isSending = true;
        try {
          await this.$store.dispatch("projects/requestSupport", {
            message
          });
          this.successfullySent = true;
        } catch (ex) {
          this.successfullySent = false;
        } finally {
          this.isSending = false;
        }
      }
    },
    closePopover() {
      this.$refs.popover.$emit("close");
      this.contactText = "";
      this.isSending = false;
      this.successfullySent = false;
      this.showContact = false;
    },
    onKey(event) {
      if (event.keyCode == 27) this.closePopover();
    },
  },
  mounted() {
    addEventListener("keydown", this.onKey);
  },
  destroyed() {
    removeEventListener("keydown", this.onKey);
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/common";

$popover-width: 30em;

#contact-popover-container {
  .help {
    z-index: 100;
    position: fixed;
    height: 30px;
    font-size: 1.2em;
    width: 30px;
    right:30px;
    padding: 0;
    cursor: pointer;
    &:not(:hover) {
      background-color: rgba(255, 255, 255, 0.7);
    }
  }
  &.fixed .help {
    position: fixed;
  }
  .popover {
    box-shadow: 0px 0px 4px $eepos-grey;
    z-index: 10;
    min-width: $popover-width;
    max-width: $popover-width;
    width: $popover-width;
    padding: 10px;
  }
}
.arrow {
  top: 332px !important;
}
.button-wrapper {
  display: flex;
  margin-top: 10px;
  justify-content: center;
}
</style>
